// src/pages/Contact.jsx
import React from 'react';
import { useTranslation } from '../context/TranslationContext';

export default function Contact() {
  const { t } = useTranslation();

  return (
    <section id="contacto" className="py-16 bg-gray-200">
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-8 text-indigo-900">
          {t('contact_title')}
        </h2>

        {/* Social Link */}
        <div className="flex justify-center mb-8">
          <a
            href="https://linkedin.com/company/qyntix"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-900 hover:text-cyan-500 transition"
            aria-label="LinkedIn de Qyntix"
          >
            <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        </div>

        {/* Contact Form */}
        <div className="max-w-xl mx-auto">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <form
              id="contact-form"
              className="space-y-6"
              action="https://formspree.io/f/mwpobpdo"
              method="POST"
            >
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact_name_label')}
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-cyan-500"
                  required
                  aria-describedby="name-error"
                />
                <p id="name-error" className="text-red-500 text-sm hidden">
                  {t('contact_name_error')}
                </p>
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact_email_label')}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-cyan-500"
                  required
                  aria-describedby="email-error"
                />
                <p id="email-error" className="text-red-500 text-sm hidden">
                  {t('contact_email_error')}
                </p>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('contact_message_label')}
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-cyan-500"
                  required
                  aria-describedby="message-error"
                ></textarea>
                <p id="message-error" className="text-red-500 text-sm hidden">
                  {t('contact_message_error')}
                </p>
              </div>

              <button
                type="submit"
                className="w-full py-3 text-lg font-semibold bg-indigo-900 text-white rounded-lg hover:bg-cyan-500 transition-colors"
                aria-label="Enviar formulario de contacto de Qyntix"
              >
                {t('contact_submit')}
              </button>
            </form>

            <div id="success-message" className="hidden text-center text-green-600 mt-4 animate-fade-in">
              <p>{t('contact_success')}</p>
            </div>
            <div id="error-message" className="hidden text-center text-red-600 mt-4 animate-fade-in">
              <p>{t('contact_error')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}